// extracted by mini-css-extract-plugin
export var modal = "_ko-0";